import Message from "../../message";
import {useMainStore} from "@/store";

export default class GuildVipPointsDecayed extends Message
{
    handle()
    {
        useMainStore().DECREMENT_GUILD_VIP_POINTS(this.message.points);
    }
}
